import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { redeemCouponToProfile } from '@/utils/api/coupon';

export interface AffiliateCouponState {
  code: string;
  isLoading: boolean;
  isRedeemed: boolean;
}

const initialState: AffiliateCouponState = {
  code: '',
  isLoading: false,
  isRedeemed: false,
};

export const applyCodeToProfile = createAsyncThunk<string, string, { state: { coupon: AffiliateCouponState } }>(
  'applyCodeToProfile',
  async (arg) => {
    const coupon = await redeemCouponToProfile(arg);

    if (coupon.isValid) {
      return arg;
    }
    throw new Error('Couldn’t redeeem applied coupon');
  },
);

export const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    setCouponCode(state, action: PayloadAction<string>) {
      state.code = action.payload;
      state.isLoading = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(applyCodeToProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(applyCodeToProfile.fulfilled, (state, arg) => {
      state.code = arg.payload;
      state.isLoading = false;
      state.isRedeemed = true;
    });
  },
});

export const { setCouponCode } = couponSlice.actions;
